import dayjs from 'dayjs';

/**
 * Formats a program date such as "2026-07-27" as "Jul 27, 2026".
 *
 * Program dates are calendar days. Parsing them as instants shifts them in
 * time zones west of UTC ("2026-07-27T00:00:00Z" is Jul 26 in California),
 * so read the YYYY-MM-DD part as written and ignore any time.
 */
export const formatCalendarDate = (date?: string | Date | null): string => {
  if (!date) return '';
  const calendarDay =
    typeof date === 'string' && /^\d{4}-\d{2}-\d{2}/.test(date)
      ? dayjs(date.slice(0, 10))
      : dayjs(date);
  return calendarDay.isValid() ? calendarDay.format('MMM D, YYYY') : '';
};
